var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IMG',{attrs:{"src":_vm.m_Src},on:{"click":_vm.OnClick}})}
var staticRenderFns = []

export { render, staticRenderFns }